module.exports = __webpack_public_path__ + "media/application/images/2023/02_still-1920x1080-9200d0f49d83290499022ba9963c2797.png";